import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async getPaginateList({ commit }, payload) {
    const apiResult = await apiService.post(
      route('member.fcs.custom-forest-management-plan-detail.get-paginate-list'),
      payload
    )
    if (apiResult && apiResult.success) {
      return apiResult.data
    }
    return false
  },
  async getList({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.custom-forest-management-plan-detail.get-list'), payload)
    if (apiResult && apiResult.success) {
      return apiResult.data
    }
    return false
  },
  async updateProjectExecutionArea({ commit }, params) {
    const apiResult = await apiService.post(
      route('member.fcs.custom-forest-management-plan-detail.update-project-execution-area'),
      params
    )
    if (apiResult) {
      return apiResult
    }
  },
  async updateForestIndividualParameters({ commit }, payload) {
    const apiResult = await apiService.post(
      route('member.fcs.custom-forest-management-plan-detail.update-forest-individual-parameters'),
      payload
    )
    if (apiResult) {
      return apiResult
    }
  },
  async updateCustomForestManagementPlan({ commit }, params) {
    const apiResult = await apiService.post(route('member.fcs.custom-forest-management-plan-detail.update'), params)
    if (apiResult) {
      return apiResult
    }
  },
  async getTreeSpeciesOptions({ commit }, params) {
    const apiResult = await apiService.post(
      route('member.fcs.custom-forest-management-plan-detail.get-tree-species-options'),
      params
    )
    if (apiResult) {
      return apiResult
    }
  },
  async getTreeSpeciesList({ commit }, params) {
    const apiResult = await apiService.post(
      route('member.fcs.custom-forest-management-plan-detail.get-tree-species-list'),
      params
    )
    if (apiResult.success) {
      return apiResult.data
    }
    return false
  },
  async getManagementPlanIds({ commit }, params) {
    const apiResult = await apiService.post(
      route('member.fcs.custom-forest-management-plan-detail.get-management-plan-ids'),
      params
    )
    if (apiResult.success) {
      return apiResult.data
    }
    return false
  },
  async getForestManagementPlansByProject({ commit }, params) {
    const apiResult = await apiService.post(
      route('member.fcs.custom-forest-management-plan-detail.get-forest-management-plans-by-project'),
      params
    )
    if (apiResult.success) {
      return apiResult.data
    }
    return false
  },
}

export default {
  state,
  mutations,
  actions,
}
